interface IconProps {
  color?: string
}

export const Info = ({ color }: IconProps) => {
  return (
    <svg
      aria-hidden="true"
      width="20px"
      height="20px"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99992 3.04134C6.15694 3.04134 3.04159 6.15669 3.04159 9.99967C3.04159 13.8427 6.15694 16.958 9.99992 16.958C13.8429 16.958 16.9583 13.8427 16.9583 9.99967C16.9583 6.15669 13.8429 3.04134 9.99992 3.04134ZM1.95825 9.99967C1.95825 5.55838 5.55863 1.95801 9.99992 1.95801C14.4412 1.95801 18.0416 5.55838 18.0416 9.99967C18.0416 14.441 14.4412 18.0413 9.99992 18.0413C5.55863 18.0413 1.95825 14.441 1.95825 9.99967Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99992 14.708C9.70076 14.708 9.45825 14.4655 9.45825 14.1663L9.45825 9.16634C9.45825 8.86719 9.70076 8.62467 9.99992 8.62467C10.2991 8.62467 10.5416 8.86719 10.5416 9.16634V14.1663C10.5416 14.4655 10.2991 14.708 9.99992 14.708Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M10.6249 6.45801C10.6249 6.11283 10.3451 5.83301 9.99992 5.83301C9.65474 5.83301 9.37492 6.11283 9.37492 6.45801C9.37492 6.80319 9.65474 7.08301 9.99992 7.08301C10.3451 7.08301 10.6249 6.80319 10.6249 6.45801Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  )
}
